import { render, staticRenderFns } from "./RevisionLogsViewer.vue?vue&type=template&id=168f55b7&scoped=true&lang=pug"
import script from "./RevisionLogsViewer.vue?vue&type=script&lang=js"
export * from "./RevisionLogsViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168f55b7",
  null
  
)

export default component.exports